import { render } from "./DetailTable.vue?vue&type=template&id=31066e76&scoped=true"
import script from "./DetailTable.vue?vue&type=script&lang=js"
export * from "./DetailTable.vue?vue&type=script&lang=js"

import "./DetailTable.vue?vue&type=style&index=0&id=31066e76&scoped=true&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31066e76"]])

export default __exports__